import { useNavigate } from "react-router-dom";
import { ArrowLeft, Check, Sparkles, Calendar } from "lucide-react";

export default function SpecialistServiceDetail({ testid, eyebrow, title, subtitle, image, accent, box, offerings = [], aiPrompt }) {
  const navigate = useNavigate();
  return (
    <div className="space-y-5" data-testid={testid}>
      <div className="flex items-center gap-2">
        <button onClick={() => navigate(-1)} className="h-9 w-9 rounded-full flex items-center justify-center hover:bg-accent" data-testid={`${testid}-back`}>
          <ArrowLeft className="h-5 w-5" style={{ color: "#15296B" }} />
        </button>
        <h1 className="text-xl md:text-2xl font-bold" style={{ color: "#15296B" }}>{title}</h1>
      </div>

      <div className="relative overflow-hidden rounded-3xl" style={{ minHeight: 190 }}>
        <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(10,20,50,0.78) 30%, rgba(10,20,50,0.25))" }} />
        <div className="relative z-10 p-6 max-w-[70%]">
          <span className="inline-block text-xs font-extrabold tracking-[0.12em] px-2.5 py-1 rounded-full" style={{ backgroundColor: box, color: accent }}>{eyebrow}</span>
          <h2 className="mt-3 text-2xl font-black text-white leading-tight">{subtitle}</h2>
        </div>
      </div>

      <div className="rounded-3xl border border-border bg-card p-5">
        <p className="font-semibold" style={{ color: "#15296B" }}>What's included</p>
        <div className="mt-3 space-y-2.5">
          {offerings.map((o, i) => (
            <div key={i} className="flex items-start gap-3">
              <span className="mt-0.5 h-6 w-6 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: box }}>
                <Check className="h-3.5 w-3.5" style={{ color: accent }} />
              </span>
              <p className="text-sm text-slate-700 flex-1">{o}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button onClick={() => navigate("/find-care")} data-testid={`${testid}-book`} className="flex items-center justify-center gap-2 rounded-2xl py-3.5 font-bold text-white" style={{ backgroundColor: accent }}>
          <Calendar className="h-4.5 w-4.5" /> Book a consultation
        </button>
        <button onClick={() => navigate(`/assistant${aiPrompt ? `?q=${encodeURIComponent(aiPrompt)}` : ""}`)} data-testid={`${testid}-ai`} className="flex items-center justify-center gap-2 rounded-2xl py-3.5 font-bold border border-border bg-card hover:bg-accent">
          <Sparkles className="h-4.5 w-4.5" style={{ color: "#7C3AED" }} /> Ask Dr Sanjeevani
        </button>
      </div>
    </div>
  );
}
